import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import AuthLayout from '../../../../layout/AuthLayout'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { Box, Grid, LoadingOverlay, SimpleGrid, Tabs, Text, Image, Stack, Group, Button, NumberFormatter, Divider, Flex, Paper, Menu, Modal } from '@mantine/core'
import NoImage from '../../../../assets/img/images/no-images.png'
import { getProductDetail, resetProduct } from '../../../../store/productDetail'
import ProductSummary from '../../../../component/pages/Product/Detail/Summary/ProductSummary'
import ProductOrigin from '../../../../component/pages/Product/Detail/ProductOrigin'
import ProductLanguage from '../../../../component/pages/Product/Detail/ProductLanguage'
// import ProductCategory from '../../../../component/pages/Product/Detail/ProductCategory'
import ProductWholesaleAndBundlePrice from '../../../../component/pages/Product/Detail/ProductWholesaleAndBundlePrice'
import ProductVariants from '../../../../component/pages/Product/Detail/ProductVariants'
import ProductImageAndVideo from '../../../../component/pages/Product/Detail/ProductImageAndVideo'
import ProductInsights from '../../../../component/pages/Product/Detail/ProductInsights'
import { IconExternalLink, IconTrash } from '@tabler/icons-react'
import dayjs from 'dayjs'
import { cloneProduct, deleteProduct } from '../../../../services/products'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'
import { notificationError, notificationSuccess } from '../../../../component/ui/Notifications'
import { IconShare } from '@tabler/icons-react'
import ShareLinkProduct from '../../../../component/pages/Product/Detail/ShareLinkProduct'
import ProductBranch from '../../../../component/pages/Product/Detail/ProductBranch'
import { modals } from '@mantine/modals'
import SearchMascot from '../../../../assets/img/mascot/18.png'
import { useLocalStorage } from '@mantine/hooks'

const defaultTab = [
  {
    label: 'Summary',
    value: 'summary'
  },
  {
    label: 'Origin',
    value: 'origin'
  },
  {
    label: 'Language',
    value: 'language'
  },
  // {
  //   label: 'Category',
  //   value: 'category'
  // },
  {
    label: 'Wholesale and Bundle Price',
    value: 'wholesaleAndBundlePrice'
  },
  {
    label: 'Variants',
    value: 'variants'
  },
  {
    label: 'Image and Video',
    value: 'imageAndVideo'
  },
  {
    label: 'Insights',
    value: 'insights'
  },
  {
    label: 'Sub-Products',
    value: 'branch'
  },
]

const defaultPanel = [
  {
    value: 'summary',
    component: ProductSummary,
  },
  {
    value: 'origin',
    component: ProductOrigin,
  },
  {
    value: 'language',
    component: ProductLanguage,
  },
  // {
  //   value: 'category',
  //   component: ProductCategory,
  // },
  {
    value: 'wholesaleAndBundlePrice',
    component: ProductWholesaleAndBundlePrice,
  },
  {
    value: 'variants',
    component: ProductVariants,
  },
  {
    value: 'imageAndVideo',
    component: ProductImageAndVideo,
  },
  {
    value: 'insights',
    component: ProductInsights,
  },
  {
    value: 'branch',
    component: ProductBranch,
  },
]

const LayoutPromptCloneProduct = ({ detailProduct }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loadingCloneProduct, setLoadingCloneProduct] = useState(false)

  const handleCloneProduct = async (idProduct) => {
    setLoadingCloneProduct(true)
    const payload = {
      id: idProduct
    }
    try {
      const response = await cloneProduct(payload)
      if (response.success) {
        notificationSuccess('Clone Product Success', 'You have been cloned product, please wait for a moment...')
        navigate(`/product/${response.data.id}`)
        const mappingRoute = [
          {
            label: '/',
            route: null
          },
          {
            label: 'Product',
            route: '/product/all'
          },
          {
            label: response.data.id,
            route: null
          },
        ]
        dispatch(updateRoute({ 'data': mappingRoute }))
        dispatch(getProductDetail(response.data.id))
        modals.closeAll()
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      notificationError('Clone Product Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    } finally {
      setLoadingCloneProduct(false)
    }
  }

  return (
    <Box>
      <Box ta='center'>
        <Image src={SearchMascot} fit='contain' h='180' my={20} />
        <Text fw={500} mb={4}>Are you sure you want to clone this product?</Text>
        <Text fw='bold' mb={14} h={20} lineClamp={2}>"{detailProduct.title}"</Text>
        <Text fz='xs' c='gray.6' mb={20}>This action will create a new product with the prefix "clone_" added to the product name, slug, and SKU, which you will need to adjust later.</Text>
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" color='red' onClick={() => modals.closeAll()}>Close</Button>
            <Button size='xs'
              variant="filled"
              color="red"
              loading={loadingCloneProduct}
              onClick={() => handleCloneProduct(detailProduct.productId)}
            >
              Clone Product
            </Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

const DetailProduct = () => {
  const navigate = useNavigate()
  const { isLoadingProduct, summary } = useSelector(state => state.product_detail)

  const dispatch = useDispatch()
  const params = useParams()
  const [searchParams] = useSearchParams()

  const productId = params.product_id
  const tab = searchParams.get("tab"); // If URL is like /path?id=123

  const [activeTab, setActiveTab] = useState('summary')

  const [selectedBulkIds, setSelectedBulkIds] = useLocalStorage({
    key: 'bulk-edit-product-ids',
    defaultValue: []
  })

  const isSelectedForBulk = selectedBulkIds.includes(Number(productId))

  const handleToggleBulk = () => {
    setSelectedBulkIds((prev) => {
      const numericId = Number(productId)
      if (prev.includes(numericId)) {
        return prev.filter(id => id !== numericId)
      } else {
        return [...prev, numericId]
      }
    })
  }

  // sevice
  const [openModalShareLink, setOpenModalShareLink] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Product',
      route: '/product/all'
    },
    {
      label: productId,
      route: null
    },
  ]

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    dispatch(getProductDetail(productId))

    return () => {
      dispatch(resetProduct())
    }
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    if (tab) {
      setActiveTab(tab)
    }
    // eslint-disable-next-line
  }, [tab])

  const refresh = () => {
    dispatch(getProductDetail(productId))
  }

  const goToProductList = () => {
    navigate('/product/all')
  }

  const cloneProduct = (summaryProduct) => {
    return modals.open({
      centered: true,
      withCloseButton: false,
      size: 'lg',
      children: (
        <LayoutPromptCloneProduct detailProduct={summaryProduct} />
      )
    })
  }

  const handleDeleteData = (productId) => {
    modalDeleteData('Product', productId, summary.title, deleteProduct, goToProductList)
  }

  const detailProductLayout = () => {
    const topSection = () => {
      return(
        <Grid gutter="xl">
          <Grid.Col span={2}>
            <Image w={200} h={200} radius='md' src={summary.image !== null ? summary.image : NoImage} />
          </Grid.Col>
          <Grid.Col span={10}>
            <Stack px={20}>
              <Group justify="space-between" preventGrowOverflow={false} wrap="nowrap">
                <Text size="lg" fw={700} lineClamp={1}>
                  {summary.title}
                </Text>

                <Group wrap="nowrap">
                  <Button
                    variant="light"
                    color={isSelectedForBulk ? "red" : "gray"}
                    size="xs"
                    radius="sm"
                    onClick={handleToggleBulk}
                  >
                    {isSelectedForBulk ? "Remove from Bulk Edit" : "Add to Bulk Edit"}
                  </Button>
                  <Button
                    variant="light"
                    color="gray"
                    size="xs"
                    radius="sm"
                    onClick={() => cloneProduct(summary)}
                  >
                    Clone
                  </Button>
                  <Button
                    variant="light"
                    color="red"
                    size="xs"
                    radius="sm"
                    leftSection={<IconTrash size={14} />}
                    onClick={() => handleDeleteData(productId)}
                  >
                    Delete
                  </Button>
                </Group>
              </Group>

              <Divider mb="md" />

              <SimpleGrid cols={{ base: 2, sm: 3, lg: 5 }}>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Retail Price</Text>
                  <Text fz={16} c='red.6' mb={4} fw={500}>
                    <NumberFormatter prefix={`${summary.originalCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.regularPrice} />
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Sale Price</Text>
                  <Text fz={16} c='red.6' mb={4} fw={500}>
                    <NumberFormatter prefix={`${summary.originalCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.salePrice} />
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Dropship Price</Text>
                  <Text fz={16} c='red.6' mb={4} fw={500}>
                    <NumberFormatter prefix={`${summary.originalCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.resellerPrice} />
                  </Text>
                </Box>

                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Product Source</Text>
                  <Text fz={16} c='black' mb={4} fw={500}>
                    {summary?.source?.name || 'N/A'}
                  </Text>
                </Box>


                <Box>
                  <Flex align='center' mb={2}>
                    <Text fz={12} c='gray.6'>Created By</Text>
                  </Flex>
                  <Box>
                    {
                      summary.creator.id !== 0
                        ? <Text fz={14} fw='500' c='blue.6' lineClamp={2}>
                          {summary.creator.name} <span style={{ cursor: 'pointer'}} onClick={() => navigate(`/users/${summary.creator.id}`)}><IconExternalLink size={14} /></span>
                        </Text>
                        : <Text fz={14} fw='500' c='gray.6' lineClamp={2}>
                          Auto Sync Admin
                        </Text>
                    }
                    <Text fz={10} c='gray.6'>{dayjs(summary.createdAt).format('DD/MMMM/YYYY')} - { dayjs(summary.createdAt).format('HH:mm:ss')}</Text>
                  </Box>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Stock</Text>
                  <Text fz={16} c='black' mb={4} fw={500}>
                    {summary.quantity} {summary.quantityUnit}
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Min Order Qty</Text>
                  <Text fz={16} c='black' mb={4} fw={500}>
                    {summary.minimumQuantity} {summary.quantityUnit}
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Weight</Text>
                  <Text fz={16} c='black' mb={4} fw={500}>
                    {summary.weight} {summary.weightUnit}
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Import From Url</Text>
                  <Text fz={16} c='black' mb={4} fw={500}>
                    {summary.merchant || '-'}
                  </Text>
                </Box>
                <Box>
                  <Flex align='center' mb={2}>
                    <Text fz={12} c='gray.6'>Updated By</Text>
                  </Flex>
                  <Box>
                    {
                      summary.updater.id !== 0
                        ? <Text fz={14} fw='500' c='blue.6' lineClamp={2}>
                          {summary.updater.name} <span style={{ cursor: 'pointer' }} onClick={() => navigate(`/users/${summary.updater.id}`)}><IconExternalLink size={14} /></span>
                        </Text>
                        : <Text fz={14} fw='500' c='gray.6' lineClamp={2}>
                          Auto Sync Admin
                        </Text>
                    }
                    <Text fz={10} c='gray.6'>{dayjs(summary.updatedAt).format('DD/MMMM/YYYY')} - { dayjs(summary.updatedAt).format('HH:mm:ss')}</Text>
                  </Box>
                </Box>
              </SimpleGrid>
            </Stack>
          </Grid.Col>

        </Grid>
      )
    }

    const mappingTab = (dataTopTabs) => {
      const remapTopTabs = dataTopTabs.map((val, index) => {
        return (<Tabs.Tab key={index} value={val.value} style={{ color: val.value === activeTab ? 'red' : 'gray', fontWeight: val.value === activeTab ? 'bold' : '400' }}>{val.label}</Tabs.Tab>)
      })
      return remapTopTabs
    }

    const mappingPanel = (dataTopPanels) => {
      const remapTopPanels = dataTopPanels.map((val, index) => {
        return (<Tabs.Panel key={`${index}`} value={val.value}><val.component productId={productId} reloadProduct={() => refresh()} /></Tabs.Panel>)
      })
      return remapTopPanels
    }

    return (
      <Box my={15}>
        <Paper withBorder radius="md" p="md">
          {topSection()}
        </Paper>

        <Paper withBorder radius="md" p="md" my={16}>
          <Tabs value={activeTab} keepMounted={false} onChange={setActiveTab}>
            <Tabs.List>
              {mappingTab(defaultTab)}
            </Tabs.List>

            {mappingPanel(defaultPanel)}
          </Tabs>
        </Paper>
      </Box>
    )
  }

  const showButtonShareProduct = () => {
    return (
      <Box style={{ position: 'absolute', right: 0, top: '-42px' }}>
        <Menu width={170} position="bottom-end" withArrow arrowPosition="center">
          <Menu.Target>
            <Button size="xs" radius="md">Share</Button>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              leftSection={<IconShare stroke={1.5} size={14} />}
              onClick={() => [setOpenModalShareLink(true), setDetailData(summary)]}
              fw='600'
              fz={11}
            >
              Share Product URL
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Box>
    )
  }

  const onCloseModalShareLink = () => {
    setOpenModalShareLink(false)
    setDetailData(null)
  }

  return (
    <AuthLayout>
      <Box pos='relative' pb={15}>
        <LoadingOverlay visible={isLoadingProduct} zIndex={1000} overlayProps={{ radius: "sm", blur: 5 }} />
        {!isLoadingProduct ? showButtonShareProduct() : ''}
        {detailProductLayout()}
      </Box>
      <Modal opened={openModalShareLink} onClose={onCloseModalShareLink} centered closeOnClickOutside={false} size='80%' title={<Text fw='Bold'>Share Product ID {productId}</Text>} withCloseButton={false}>
        <ShareLinkProduct dataProduct={detailData} onCloseModal={onCloseModalShareLink} />
      </Modal>
    </AuthLayout>
  )
}

export default DetailProduct